/**
 * @generated SignedSource<<18a2d936d4dceb25c2b8b3c72c604bc8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GroupSettingsScreen_rootRef$data = {
  readonly group: {
    readonly " $fragmentSpreads": FragmentRefs<"GroupSettingsCard_group" | "RefreshSlug">;
  } | null | undefined;
  readonly " $fragmentType": "GroupSettingsScreen_rootRef";
};
export type GroupSettingsScreen_rootRef$key = {
  readonly " $data"?: GroupSettingsScreen_rootRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupSettingsScreen_rootRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "slug"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "GroupSettingsScreen_rootRef",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "slug"
        }
      ],
      "concreteType": "Group",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RefreshSlug"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "GroupSettingsCard_group"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Root",
  "abstractKey": null
};

(node as any).hash = "c5cb1272ddc104a0be5b3cf66b411c2e";

export default node;
